<div class="flex min-w-0 flex-1 flex-col items-start justify-start p-3">
  <div class="flex w-full flex-col" [class.pl-6]="row().configurationGroup">
    <div class="flex items-center gap-2">
      <span class="text-lg font-semibold">{{ row().label }}</span>
      @if (row().description; as description) {
        <aw-tooltip
          class="inline-flex items-center self-center"
          [text]="description" />
      }
      @if (row().link; as link) {
        <a
          class="text-primary-main hover:bg-standard-hover-main hover:text-standard-text-main flex items-center rounded-md p-1 transition-colors"
          [href]="link"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="
            row().label + ' ' + cmsTextProvider.configuration.openInNewTab
          "
          [title]="
            row().label + ' ' + cmsTextProvider.configuration.openInNewTab
          ">
          <span class="material-symbols-rounded" style="font-size: 1.125rem">
            open_in_new
          </span>
        </a>
      }
    </div>
  </div>
</div>

@if (singleColumnSetting(); as setting) {
  <div
    class="flex min-w-0 shrink grow-2 basis-0 items-center gap-5 p-3"
    [ngClass]="{
      'justify-start': hasSingleActiveLicenseChannel(),
      'justify-center': !hasSingleActiveLicenseChannel(),
    }">
    @if (!hasSingleActiveLicenseChannel()) {
      <span
        class="bg-standard-outline-tonal h-px min-w-6 flex-1"
        aria-hidden="true"></span>
    }
    <div
      class="flex shrink-0 items-center justify-center"
      [ngClass]="{
        'w-full max-w-1/2 *:w-full': !isCompactConfigurationInput(setting),
      }">
      @if (singleColumnControl(); as control) {
        <aw-configuration-setting-input
          class="block"
          [setting]="setting"
          [control]="control" />
      }
    </div>
    @if (!hasSingleActiveLicenseChannel()) {
      <span
        class="bg-standard-outline-tonal h-px min-w-6 flex-1"
        aria-hidden="true"></span>
    }
  </div>
} @else {
  <div
    class="flex min-w-0 items-center p-3"
    [ngClass]="{
      'flex-1': showWeb() && showApp(),
      'grow-2 basis-0': showWeb() && !showApp(),
      'justify-center':
        showWeb() && showApp() && !isCompactConfigurationInput(row().web),
      'justify-start':
        (showWeb() && !showApp()) || isCompactConfigurationInput(row().web),
      hidden: !showWeb(),
    }">
    @if (row().web; as setting) {
      <div
        class="flex shrink-0 items-center justify-center"
        [ngClass]="{
          'w-full *:w-full':
            hasSingleActiveLicenseChannel() &&
            !isCompactConfigurationInput(setting),
          'w-full px-2 *:w-full':
            !hasSingleActiveLicenseChannel() &&
            !isCompactConfigurationInput(setting),
        }">
        @if (webControl(); as control) {
          <aw-configuration-setting-input
            class="block"
            [setting]="setting"
            [control]="control" />
        }
      </div>
    } @else {
      <aw-tooltip
        [text]="cmsTextProvider.configuration.unavailableForProduct"
        [hoverDelayMs]="tooltipHoverDelayMs"
        [showIcon]="false">
        <span
          tabindex="0"
          class="material-symbols-rounded text-standard-text-secondary"
          [attr.aria-label]="
            cmsTextProvider.configuration.unavailableForProduct
          ">
          block
        </span>
      </aw-tooltip>
    }
  </div>
  <div
    class="relative flex min-w-0 items-center p-3"
    [ngClass]="{
      'flex-1': showWeb() && showApp(),
      'grow-2 basis-0': showApp() && !showWeb(),
      'justify-center':
        showWeb() && showApp() && !isCompactConfigurationInput(row().app),
      'justify-start':
        (showApp() && !showWeb()) || isCompactConfigurationInput(row().app),
      hidden: !showApp(),
    }">
    <span
      class="bg-standard-divider absolute inset-y-5 left-0 w-px"
      [class.hidden]="!showWeb()"
      aria-hidden="true"></span>
    @if (row().app; as setting) {
      <div
        class="flex shrink-0 items-center justify-center"
        [ngClass]="{
          'w-full *:w-full':
            hasSingleActiveLicenseChannel() &&
            !isCompactConfigurationInput(setting),
          'w-full px-2 *:w-full':
            !hasSingleActiveLicenseChannel() &&
            !isCompactConfigurationInput(setting),
        }">
        @if (appControl(); as control) {
          <aw-configuration-setting-input
            class="block"
            [setting]="setting"
            [control]="control" />
        }
      </div>
    } @else {
      <aw-tooltip
        [text]="cmsTextProvider.configuration.unavailableForProduct"
        [hoverDelayMs]="tooltipHoverDelayMs"
        [showIcon]="false">
        <span
          tabindex="0"
          class="material-symbols-rounded text-standard-text-secondary"
          [attr.aria-label]="
            cmsTextProvider.configuration.unavailableForProduct
          ">
          block
        </span>
      </aw-tooltip>
    }
  </div>
}

@if (!hasSingleActiveLicenseChannel()) {
  <div class="relative flex w-16 shrink-0 items-center justify-end p-3">
    <aw-tooltip
      [showIcon]="false"
      [hoverDelayMs]="tooltipHoverDelayMs"
      horizontalAlignment="right"
      [text]="settingLinkTooltip()">
      <button
        class="flex size-10 items-center justify-center rounded-md transition-colors"
        [ngClass]="
          settingLinkDisabled()
            ? 'bg-background-disabled text-standard-icon-disabled cursor-not-allowed'
            : isSettingLinked()
              ? 'border-tonal-outlined-border bg-base-tonal text-standard-text-primary hover:bg-standard-hover-main cursor-pointer border'
              : 'text-error-main hover:bg-danger-hover cursor-pointer'
        "
        type="button"
        [disabled]="settingLinkDisabled()"
        [attr.aria-label]="settingLinkAriaLabel()"
        (click)="settingLinkToggled.emit()">
        <span class="material-symbols-rounded text-xl!">
          {{ isSettingLinked() ? 'link' : 'link_off' }}
        </span>
      </button>
    </aw-tooltip>

    @if (mergeMenuOpen()) {
      <aw-configuration-channel-menu
        class="absolute top-12 right-3 z-10"
        (closed)="mergeMenuClosed.emit()"
        (channelSelected)="mergeChannelSelected.emit($event)" />
    }
  </div>
}
